import { OpenAPI, SettingsService } from "../api/generated"

OpenAPI.BASE = import.meta.env.VITE_API_ENDPOINT

export const getAllTeams = SettingsService.getAllTeamsSettingsTeamsAllGet

export const createTeam = SettingsService.createTeamSettingsTeamsCreatePost

export const updateTeam = SettingsService.modifyTeamSettingsTeamsIdUpdatePatch

export const deleteTeam = SettingsService.deleteTeamSettingsTeamsIdDeleteDelete

export const getUserTeams = SettingsService.getUsersForTeamMappingUsersTeamMappingGet

export const updateUserTeams = SettingsService.updateUserTeamMappingUsersTeamMappingUserIdPatch

